<template>
  <div class="row content-movimentation">
    <div
      :class="[
        'd-flex align-items-center pt-0 pb-0',
        report_type == 'analytical' && 'col-md-7',
        report_type == 'general' && 'col-md-7',
      ]"
    >
      <div v-if="report_type == 'general'">
        <h6 class="row">
          <span class="col-md-2 pt-0 pb-0 date-amount"
            >{{ moment(date.dateInit).format("DD") }}/</span
          >
          <span class="col-md-2 pt-0 pb-0 date-amount"
            >{{ moment(date.dateInit).format("MM") }}/</span
          >
          <span class="col-md-2 pt-0 pb-0 date-amount">{{
            moment(date.dateInit).format("YYYY")
          }}</span>
        </h6>
      </div>
      <div>
        <h6 class="row">
          <span class="col-md-2 pt-0 pb-0 date-amount"
            >{{ moment(date.date).format("DD") }}/</span
          >
          <span class="col-md-2 pt-0 pb-0 date-amount"
            >{{ moment(date.date).format("MM") }}/</span
          >
          <span class="col-md-2 pt-0 pb-0 date-amount">{{
            moment(date.date).format("YYYY")
          }}</span>
        </h6>
      </div>
    </div>
    <div class="text-center pt-0 pb-0 col-md-1">
      <h6 class="m-0 text-amount">
        {{ date.stockInput.totalAmountInput }}
        {{ unit_of_measurement_abbreviation }}
      </h6>
    </div>
    <div class="text-center pt-0 pb-0 col-md-1">
      <h6 class="m-0 text-amount">
        {{ date.stockOutput.totalAmountOutput }}
        {{ unit_of_measurement_abbreviation }}
      </h6>
    </div>
    <div class="text-center pt-0 pb-0 col-md-1">
      <h6 class="m-0 text-amount">
        {{ date.stockOutput.totalAmountLoss }}
        {{ unit_of_measurement_abbreviation }}
      </h6>
    </div>
    <div class="text-center pt-0 pb-0 col-md-2">
      <h6 class="m-0 text-amount">
        {{ date.totalInStock }} {{ unit_of_measurement_abbreviation }}
      </h6>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import { professionalClassCouncilValue } from "../../../lib/format";

export default {
  name: "Resident",
  props: {
    date: Object,
    report_type: String,
    show_movimentation: Boolean,
    show_movimentation_lot: Boolean,
    show_movimentation_shelf_life: Boolean,
    show_movimentation_owner: Boolean,
    medicine_name: String,
    active_ingredient: String,
    unit_of_measurement_abbreviation: String,
  },
  methods: {
    moment,
    professionalClassCouncilValue,
  },
};
</script>
